import { useFormik } from "formik";
import React, { useState } from "react";
import {
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap";
import EmailConfigService from "../../services/KangarooServices/EmailConfigService";
import toast from "react-hot-toast";

const EmailConfigForm = ({ isOpen, toggle, selectedItem, fetchData }) => {
  const [passwordShow, setPasswordShow] = useState(false);
  const formik = useFormik({
    initialValues: {
      smtpServer: selectedItem?.smtpServer || "",
      port: selectedItem?.port || "",
      enableSsl: selectedItem?.enableSsl || "",
      senderEmail: selectedItem?.senderEmail || "",
      senderPassword: selectedItem?.senderPassword || "",
      recipientEmail: selectedItem?.recipientEmail || "",
    },
    enableReinitialize: true,
    onSubmit: async (values) => {
      try {
        const response = await EmailConfigService.update(
          selectedItem?.id,
          values
        );
        fetchData();
        toggle();
        toast.success(response);
      } catch (error) {
        toast.error(error);
        console.log(error);
      }
    },
  });
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Update Email Config</ModalHeader>
      <ModalBody>
        <form onSubmit={formik.handleSubmit}>
          <FormGroup className="mb-3">
            <Label htmlFor="subtitle">Smtp Server</Label>
            <Input
              id="smtpServer"
              name="smtpServer"
              value={formik.values.smtpServer}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              invalid={formik.touched.smtpServer && !!formik.errors.smtpServer}
            />
            {formik.touched.smtpServer && formik.errors.smtpServer && (
              <FormFeedback>{formik.errors.smtpServer}</FormFeedback>
            )}
          </FormGroup>

          <FormGroup className="mb-3">
            <Label htmlFor="subtitle">Port</Label>
            <Input
              id="port"
              name="port"
              value={formik.values.port}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              invalid={formik.touched.port && !!formik.errors.port}
            />
            {formik.touched.port && formik.errors.port && (
              <FormFeedback>{formik.errors.port}</FormFeedback>
            )}
          </FormGroup>

          <FormGroup className="mb-3">
            <Label htmlFor="subtitle">Sender Email</Label>
            <Input
              id="senderEmail"
              name="senderEmail"
              value={formik.values.senderEmail}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              invalid={
                formik.touched.senderEmail && !!formik.errors.senderEmail
              }
            />
            {formik.touched.senderEmail && formik.errors.senderEmail && (
              <FormFeedback>{formik.errors.senderEmail}</FormFeedback>
            )}
          </FormGroup>

          <FormGroup className="mb-3">
            <Label htmlFor="subtitle">Recipient Email</Label>
            <Input
              id="recipientEmail"
              name="recipientEmail"
              value={formik.values.recipientEmail}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              invalid={
                formik.touched.recipientEmail && !!formik.errors.recipientEmail
              }
            />
            {formik.touched.recipientEmail && formik.errors.recipientEmail && (
              <FormFeedback>{formik.errors.recipientEmail}</FormFeedback>
            )}
          </FormGroup>
          <div className="position-relative auth-pass-inputgroup mb-3">
            <Label htmlFor="subtitle">Sender Password</Label>

            <Input
              type={passwordShow ? "text" : "password"}
              className="form-control pe-5 password-input"
              placeholder="Enter sender password"
              id="password-input"
              name="senderPassword"
              value={formik.values.senderPassword || ""}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              invalid={
                formik.touched.senderPassword && formik.errors.senderPassword
                  ? true
                  : false
              }
            />
            {formik.touched.senderPassword && formik.errors.senderPassword ? (
              <FormFeedback type="invalid">
                {formik.errors.senderPassword}
              </FormFeedback>
            ) : null}
            <button
              className="btn btn-link mt-4 pt-3 position-absolute end-0 top-0 text-decoration-none text-muted password-addon"
              type="button"
              id="password-addon"
              onClick={() => setPasswordShow(!passwordShow)}
            >
              <i className="ri-eye-fill align-middle"></i>
            </button>
          </div>
          <div className="d-flex justify-content-end gap-3 mb-3">
            <button type="submit" className="btn btn-success">
              {selectedItem ? "Update" : "Create"}
            </button>
            <button type="button" className="btn btn-danger" onClick={toggle}>
              Cancel
            </button>
          </div>
        </form>
      </ModalBody>
    </Modal>
  );
};

export default EmailConfigForm;
